module.exports = __webpack_public_path__ + "img/edit-item.fe1d64fc.svg";